export default {
	methods: {
		$_OrderMixin_adjust(amount, modifier) {
			if (modifier == 0) return 0;

			if (isNaN(modifier)) {
				var v = parseFloat(modifier, 10);
				return amount * (v / 100);
			} else {
				return parseFloat(modifier);
			}
		},
		$_OrderMixin_normalizeLine(line) {
			var total 		= line.price == '' ? 0 : line.qty * line.price;

			var adjustment	= this.$_OrderMixin_adjust(total, line.adjustment);

			var extra 		= adjustment > 0 ? adjustment : 0;
			var discount 	= adjustment < 0 ? adjustment : 0;

			total			= total + extra + discount;
			var vat			= this.$_OrderMixin_adjust(total, line.vat);

			return {
				total:		total,
				vat:		vat,
				extra:		extra,
				discount: 	discount
			};
		},
		$_OrderMixin_total(orderLines) {
			var total = 0;

			for (var i = 0; i < orderLines.length; ++i) {
				total += this.$_OrderMixin_normalizeLine(orderLines[i]).total;
			}

			return total + this.$_OrderMixin_extra(orderLines);
		},
		$_OrderMixin_vat(orderLines) {
			var total = 0;

			for (var i = 0; i < orderLines.length; ++i) {
				total += this.$_OrderMixin_normalizeLine(orderLines[i]).vat;
			}

			return total;
		},
		$_OrderMixin_discount(orderLines) {
			var total = 0;

			for (var i = 0; i < orderLines.length; ++i) {
				total += this.$_OrderMixin_normalizeLine(orderLines[i]).discount;
			}

			return total;
		},
		$_OrderMixin_extra(orderLines) {
			var total = 0;
			var i;

			for (i = 0; i < orderLines.length; ++i) {
				total += this.$_OrderMixin_normalizeLine(orderLines[i]).extra;
			}

			const extras = this.$_OrderMixin_extras(orderLines);

			for (i = 0; i < extras.length; ++i) {
				total += (extras[i].percent / 100.) * extras[i].base;
			}

			return total;
		},
		$_OrderMixin_extras(orderLines) {
			var r = [];

			// Combine matching extra lines
			let extraLines = [];

			for (let i = 0; i < orderLines.length; ++i) {
				let p = orderLines[i];

				if (p.hasOwnProperty('extra') && p.extra) {
					// Does line exist?
					let found = false;

					for (var j = 0; j < extraLines.length; ++j) {
						if (extraLines[j].label == p.extra.label && parseFloat(extraLines[j].percent) == parseFloat(p.extra.percent)) {
							extraLines[j].base += this.$_OrderMixin_normalizeLine(p).total;
							found = true;
							break;
						}
					}

					if (!found) {
						extraLines.push({
							label: 		p.extra.label,
							percent: 	p.extra.percent,
							base:		this.$_OrderMixin_normalizeLine(p).total
						});
					}
				}
			}

			// Output extra lines
			for (let i = 0; i < extraLines.length; ++i) {
				let p = extraLines[i];

				r.push({
					label: 		p.label,
					percent: 	parseFloat(p.percent),
					base:		p.base
				});
			}

			return r;
		}
	}
};